/* eslint-disable import/no-cycle */
import React from 'react';

import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { NoDataAvailable, Table } from 'ui/atoms';
import { CrudLayout } from 'ui/components';

import { columnsFirmware } from './columnsFirmware';
import { FirmwareCardMainContainer } from './style';

const FirmwareCard = ({ firmware = [] }) => (
  <FirmwareCardMainContainer>
    {firmware?.length > 0 ? (
      <CrudLayout>
        <Table
          headerColumns={columnsFirmware}
          data={firmware}
          totalPages={1}
          totalRecords={1}
          selection={false}
          detailhover
        />
      </CrudLayout>
    ) : (
      <NoDataAvailable />
    )}
  </FirmwareCardMainContainer>
);

FirmwareCard.propTypes = {
  firmware: PropTypes.array
};

export default connect(state => ({
  firmware: state?.cpDetails.firmware
}))(FirmwareCard);
